import { createContext, useState } from "react";
import { toast } from "react-hot-toast";
import clienteAxios from "../config/clienteAxios";
import createInTheWorld from "../services/createInTheWorld";

const InTheWorldContext = createContext();

const InTheWorldProvider = ({ children }) => {
  const [inTheWorld, setInTheWorld] = useState(null);
  const [mensaje, setMensaje] = useState(null);

  const getAllWorld = async () => {
    try {
      const { data } = await clienteAxios("/intheworld");
      const [firstDataWorld] = data.allInTheWorld;
      setInTheWorld(firstDataWorld);
    } catch (error) {
      console.log(error);
    }
  };

  const editWorld = async (worldEdit) => {
    try {
      const { data } = await clienteAxios.put(`intheworld/update`, worldEdit);
      setInTheWorld(worldEdit)
      toast.success("Se actualizó sección En el mundo");
    } catch (error) {
      toast.error("Error al actualizar sección En el mundo");
    }
  };

  const addWorld = (info) => {
    createInTheWorld(info).then(({ data }) => setMensaje(data.message));
    setMensaje(null);
  };

  return (
    <InTheWorldContext.Provider
      value={{
        setInTheWorld,
        inTheWorld,
        editWorld,
        addWorld,
        getAllWorld
      }}
    >
      {children}
    </InTheWorldContext.Provider>
  );
};

export { InTheWorldProvider };

export default InTheWorldContext;